import React, { useEffect } from 'react';

export default function ShippingPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{
      maxWidth: '900px',
      margin: '40px auto',
      padding: '0 20px',
      lineHeight: '1.8',
      color: '#333',
      textAlign: 'left'
    }}>
      <h1 style={{ fontSize: '32px', marginBottom: '20px' }}>Shipping Policy</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>Last updated: {new Date().toLocaleDateString()}</p>
      
      <div style={{ fontSize: '15px', textAlign: 'left' }}>
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Processing Time</h2>
          <p style={{ marginBottom: '15px' }}>
            Processing time refers to the time it takes for us to prepare your order for shipment after payment is confirmed. 
            Processing times vary depending on product availability:
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>In-Stock Items</h3>
          <p style={{ marginBottom: '15px' }}>
            For products that are currently in stock, we aim to process and ship your order within <strong>5 business days</strong> 
            (Monday through Friday, excluding holidays) from the date your order is placed.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Preorder Items</h3>
          <p style={{ marginBottom: '15px' }}>
            Some products are available for preorder and must be manufactured before shipping. Preorder items may take 
            <strong>one month or longer</strong> to manufacture, depending on the specific product and current production schedule.
          </p>
          <p style={{ marginBottom: '15px' }}>
            The estimated manufacturing timeframe will be clearly indicated on the product page at the time of purchase. 
            Please note that manufacturing times are estimates and may vary based on:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Production complexity</li>
            <li>Order volume</li>
            <li>Material availability</li>
            <li>Unforeseen manufacturing delays</li>
          </ul>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Mixed Orders</h3>
          <p style={{ marginBottom: '15px' }}>
            If your order contains both in-stock and preorder items, your entire order will ship together once all items are ready. 
            If you prefer to receive in-stock items immediately, please place separate orders.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Shipping Time</h2>
          <p style={{ marginBottom: '15px' }}>
            Shipping time is <strong>separate from and in addition to</strong> processing or manufacturing time. Once your order 
            has been processed and shipped, delivery times depend on:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Your shipping address and location</li>
            <li>The shipping method selected at checkout</li>
            <li>The shipping carrier's delivery schedule</li>
            <li>Customs clearance (for international orders)</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            Estimated shipping times will be displayed at checkout and are provided by the shipping carrier. These are estimates 
            only and are not guaranteed delivery dates.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Shipping Methods and Carriers</h2>
          <p style={{ marginBottom: '15px' }}>
            We use <strong>Shippo</strong> to calculate shipping rates and coordinate with multiple carriers to provide you with 
            the best shipping options. Available shipping methods and carriers may include:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>USPS (United States Postal Service)</li>
            <li>UPS (United Parcel Service)</li>
            <li>FedEx</li>
            <li>DHL (for international shipments)</li>
            <li>Other carriers as available</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            The specific carriers and methods available for your order will be displayed at checkout based on your shipping address.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Shipping Costs</h2>
          <p style={{ marginBottom: '15px' }}>
            Shipping costs are calculated at checkout based on:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Package weight and dimensions</li>
            <li>Destination address</li>
            <li>Selected shipping method</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            The exact shipping cost will be displayed before you complete your purchase. We do not offer free shipping unless 
            specifically stated in a promotion.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Tracking Your Order</h2>
          <p style={{ marginBottom: '15px' }}>
            Once your order has shipped, you will receive a shipping confirmation email containing:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Tracking number</li>
            <li>Carrier information</li>
            <li>Link to track your package</li>
            <li>Estimated delivery date</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            You can use the tracking number to monitor your package's progress through the carrier's website. Please allow 
            24-48 hours after shipment for tracking information to become active.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Shipping Destinations</h2>
          
          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Domestic Shipping (United States)</h3>
          <p style={{ marginBottom: '15px' }}>
            We ship to all 50 U.S. states, including Alaska and Hawaii. Please note that shipping to Alaska, Hawaii, and U.S. 
            territories may require additional time and cost.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>International Shipping</h3>
          <p style={{ marginBottom: '15px' }}>
            International shipping is available to select countries. International orders may be subject to:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Import duties, taxes, and customs fees (customer's responsibility)</li>
            <li>Customs clearance delays</li>
            <li>Longer delivery times</li>
            <li>Different return policies based on destination country laws</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            <strong>Important:</strong> You are responsible for all customs duties, import taxes, and fees charged by your country. 
            These charges are not included in your order total and are not controlled by Bokeh.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Delivery Issues</h2>
          
          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Incorrect Address</h3>
          <p style={{ marginBottom: '15px' }}>
            You are responsible for ensuring your shipping address is accurate and complete. If a package is returned to us due 
            to an incorrect or incomplete address you provided, you may be charged for reshipping costs.
          </p>
          <p style={{ marginBottom: '15px' }}>
            If you realize you've entered an incorrect address, please contact us immediately at 
            <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline', margin: '0 4px' }}>contact@bokehclo.com</a>. 
            We will attempt to update the address if the package has not yet shipped, but we cannot guarantee changes once processing has begun.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Lost or Damaged in Transit</h3>
          <p style={{ marginBottom: '15px' }}>
            If your package shows as delivered but you have not received it, please:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Check with neighbors or household members</li>
            <li>Look around your property (porches, garages, mailbox areas)</li>
            <li>Contact your local post office or carrier</li>
            <li>Check the tracking details for delivery location notes</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            If your package appears to be lost or damaged during shipping, please contact us within 48 hours of the expected 
            delivery date. We will work with the carrier to investigate and resolve the issue.
          </p>

          <h3 style={{ fontSize: '18px', marginBottom: '10px', marginTop: '20px' }}>Delivery Delays</h3>
          <p style={{ marginBottom: '15px' }}>
            While we strive to meet all estimated timeframes, we are not responsible for shipping delays caused by:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Carrier delays or service disruptions</li>
            <li>Weather conditions or natural disasters</li>
            <li>Customs processing</li>
            <li>Incorrect or incomplete address information</li>
            <li>Recipient unavailability</li>
            <li>Holidays or peak shipping seasons</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Order Changes and Cancellations</h2>
          <p style={{ marginBottom: '15px' }}>
            Once an order is placed, we begin processing immediately. If you need to cancel or modify your order, please contact 
            us at <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>contact@bokehclo.com</a> as soon as possible.
          </p>
          <p style={{ marginBottom: '15px' }}>
            We will do our best to accommodate your request, but we cannot guarantee changes or cancellations once processing has begun. 
            Once an order has shipped, it cannot be cancelled or modified.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Contact Us</h2>
          <p style={{ marginBottom: '15px' }}>
            If you have questions about shipping, tracking, or delivery, please contact us at:
          </p>
          <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', marginTop: '15px' }}>
            <p style={{ marginBottom: '8px' }}><strong>Bokeh</strong></p>
            <p style={{ marginBottom: '8px' }}>Email: <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>contact@bokehclo.com</a></p>
            <p style={{ marginBottom: '8px' }}>Website: <a href="https://bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>https://bokehclo.com</a></p>
          </div>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Changes to This Policy</h2>
          <p style={{ marginBottom: '15px' }}>
            We reserve the right to update or modify this Shipping Policy at any time. Any changes will be posted on this page 
            with an updated "Last updated" date. Your continued use of our website following any changes constitutes acceptance 
            of the updated policy.
          </p>
        </section>

        <section style={{ marginBottom: '30px', marginTop: '40px', padding: '20px', background: '#f0f0f0', borderRadius: '5px' }}>
          <p style={{ fontSize: '13px', color: '#666', fontStyle: 'italic', marginBottom: '0' }}>
            <strong>Note:</strong> All processing and shipping timeframes are estimates and may vary. We appreciate your patience 
            and understanding, especially during busy seasons or for preorder items that require manufacturing.
          </p>
        </section>
      </div>
    </div>
  );
}

